<template>
	<el-dialog :visible="showdialog" :title="dialogitem.title" :width="dialogitem.width"
	 :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" 
	 :show-close="dialogitem.isclose" @close="dialogclose" :destroy-on-close="true">
		<div v-if="dialogitem.l_id!=''">
			<controlcenter :ref="'control_'+dialogitem.l_id" :item="dialogitem" :urlparam="urlparam"></controlcenter>
		</div>
	</el-dialog>
</template>

<script>
import controlcenter from '@/pages/main/controlcenter';
export default {
	components: {
		controlcenter
	},
	props: {
		// showdialog: {
		// 	type: Boolean,
		// 	default:false
		// },
		// urlparam: {
		// 	type: Object,
		// 	default:function(){
		// 		return {};
		// 	}
		// },
		// dialogitem: {
		// 	type: Object,
		// 	default:function(){
		// 		return {};
		// 	}
		// }
	},
	data() {
		return{
			showdialog:false,
			urlparam:{},
			dialogitem:{
				title:'',
				width:'500px',
				l_id:'',
				isclose:false
			},
		}
	},
	mounted() {
		
	},
	methods:{
		init(param){
			debugger
			this.showdialog=true;
			param.item.layout='1';
			param.item.isdialog=true;
			param.item.isclose=false;
			if(param.item.l_handetype=='opensmallwin')
				param.item.width='500px';
			//debugger	
			this.dialogitem=param.item;
			this.urlparam=param.urlparam;
			//debugger
			// this.$nextTick(() => {
			// 	if(this.$refs['control_'+this.dialogitem.l_id]!=undefined){
					
			// 		this.$refs['control_'+this.dialogitem.l_id].init({
			// 			isdialog:true,
			// 			layout:'1',
			// 			l_pagetype:this.dialogitem.l_pagetype,
						
			// 		});
			// 	}
			// });
		},
		dialogclose(){
			debugger
		}
	}
}
</script>

<style>
</style>
